import { render, staticRenderFns } from "./VSnowfall.vue?vue&type=template&id=6898995e"
import script from "./VSnowfall.vue?vue&type=script&lang=js"
export * from "./VSnowfall.vue?vue&type=script&lang=js"
import style0 from "./VSnowfall.vue?vue&type=style&index=0&id=6898995e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports